var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLkClone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "41.27mm",
    height: "41.27mm",
    viewBox: "0 0 116.99 116.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #005c8e;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M112.65,42.74l-7.45-7.45-6.79-6.79-7.45-7.45-4.33-4.33h-22.28l-4.93-4.92-7.45-7.45-4.33-4.33H0v100.27h39v16.71h77.99V50.14h0v-3.06l-4.33-4.33ZM91.99,28.2l4.14,4.14,5.23,5.23,4.14,4.14,4.09,4.09h-14.89c-.11,0-.21-.03-.32-.03-1.67-.08-3.19-.76-4.33-1.83-.28-.26-.52-.55-.75-.85-.87-1.14-1.4-2.55-1.4-4.09,0-.08.02-.16.02-.24h-.02v-14.65l4.09,4.09ZM52.99,11.49l4.14,4.14,1.08,1.08h-9.32V7.4l4.09,4.09ZM4.33,95.94V4.33h40.23v12.38h-5.57v53.88h-.69c-7.58,0-13.75-6.17-13.75-13.75v-18.08h-4.33v18.08c0,4.48,1.64,8.57,4.33,11.73.62.73,1.3,1.4,2.03,2.02,3.16,2.7,7.25,4.33,11.73,4.33h.69v21.02H4.33ZM112.65,112.65H43.33v-37.73h21.03v15.82l9.3-5.37,4.33-2.5,13.78-7.96,2.61-1.51-4.89-2.83-11.5-6.64-4.33-2.5-4.96-2.87-4.33-2.5v14.51h-21.03V21.05h40.23v17.95c0,1.45.28,2.82.79,4.09,1.05,2.67,3.11,4.82,5.7,6.02,1.33.61,2.79.97,4.33,1.01v.02h18.27v62.52ZM68.69,83.24v-19.65l4.96,2.87,4.33,2.5,2.83,1.63,4.89,2.83-2.61,1.51-5.11,2.95-4.33,2.5-4.96,2.87Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLkClone);
export default __webpack_public_path__ + "static/media/LK_Clone.c2ad74f773e6931de5c54aad3ec547aa.svg";
export { ForwardRef as ReactComponent };